export default "__VITE_ASSET__6da45a17__"